import { createContext, useMemo, useReducer } from "react"
import { produce } from "immer"
import { usePreferences } from "hooks/use-preferences"

const PREFERENCE_SUBTYPE = "graph-performance"
const PREFERENCE_FIELDS = [
  "selectedCategory",
]

const DEFAULT_STATE = {
  selectedCategory: "total",
}

function reducer(current, action) {
  return produce(current, draft => {
    switch (action.type) {
      case "setSelectedCategory":
        draft.selectedCategory = action.selectedCategory
        break
      case "setPreferences":
        if (action.preferences) {
          Object.assign(draft, action.preferences)
        }
        break
    }
  })
}

function setPreferences(preferences) {
  return { type: "setPreferences", preferences }
}

export const PERFORMANCE_CONTEXT = createContext()

export default function PerformanceContext({ children }) {
  const [state, dispatch] = useReducer(reducer, DEFAULT_STATE)
  const isPreferencesLoaded = usePreferences(
    PREFERENCE_SUBTYPE,
    PREFERENCE_FIELDS,
    state,
    dispatch,
    setPreferences,
  )

  const contextUpdaters = useMemo(() => ({
    setSelectedCategory: (selectedCategory) => dispatch({ type: "setSelectedCategory", selectedCategory }),
  }), [dispatch])

  const contextValue = useMemo(() => ({
    ...state,
    ...contextUpdaters,
    isPreferencesLoaded,
  }), [state, contextUpdaters, isPreferencesLoaded])

  return <PERFORMANCE_CONTEXT.Provider value={contextValue}>
    {children}
  </PERFORMANCE_CONTEXT.Provider>
}
